import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Newsevent from "../Components/newsevent";
import axios from "axios";

const Blogs = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || "ta";
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get("https://admin.cmpranesh-admk.com/api/getEvents.php")
      .then(res => {
        const formatted = res.data.map(item => ({
          id: item.id,
          image: item.image,
          title: lang === "ta" ? item.title_ta : item.title_en,
          description: lang === "ta" ? item.content_ta : item.content_en,
          date: item.date,
          link: `/post/${item.id}`, // <-- changed to ID
          category: lang === "ta" ? item.category_ta : item.category_en
        }));
        setPosts(formatted);
      })
      .catch(err => console.error("Error fetching events:", err));
  }, [lang]);

  return <Newsevent posts={posts} />;
};

export default Blogs;
